var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternational(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#DBEAFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_10314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.36 20H21.3333C20.9797 20 20.6406 20.1405 20.3905 20.3905C20.1405 20.6406 20 20.9797 20 21.3333V24.36",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 12.2266V13.3332C14.6667 13.8637 14.8775 14.3724 15.2525 14.7474C15.6276 15.1225 16.1363 15.3332 16.6667 15.3332C17.0204 15.3332 17.3595 15.4737 17.6096 15.7238C17.8596 15.9738 18.0001 16.3129 18.0001 16.6666C18.0001 17.3999 18.6001 17.9999 19.3334 17.9999C19.687 17.9999 20.0262 17.8594 20.2762 17.6094C20.5263 17.3593 20.6667 17.0202 20.6667 16.6666C20.6667 15.9332 21.2667 15.3332 22.0001 15.3332H24.1134",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 24.6333V21.9999C17.3334 21.6463 17.1929 21.3072 16.9428 21.0571C16.6928 20.8071 16.3537 20.6666 16 20.6666C15.6464 20.6666 15.3073 20.5261 15.0572 20.2761C14.8072 20.026 14.6667 19.6869 14.6667 19.3333V18.6666C14.6667 18.313 14.5262 17.9738 14.2762 17.7238C14.0261 17.4737 13.687 17.3333 13.3334 17.3333H11.3667",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 24.6666C21.6818 24.6666 24.6666 21.6818 24.6666 17.9999C24.6666 14.318 21.6818 11.3333 17.9999 11.3333C14.318 11.3333 11.3333 14.318 11.3333 17.9999C11.3333 21.6818 14.318 24.6666 17.9999 24.6666Z",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_10314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternational);
export default __webpack_public_path__ + "static/media/international.0ad6e46a31722192cb0c7feb66850c5f.svg";
export { ForwardRef as ReactComponent };